import {Dropdown, Button, Badge, Drawer} from 'antd';
import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import {LazyNotificationsList} from '../../../../ui/src';

import AccountMenu from './accountMenu';
import './accountSwitcher.css';
import {BellOutlined, UserOutlined} from "@ant-design/icons";

export function AccountSwitcher({
  client,
  team_member,
  notifications,
  toggleNotifications,
  onClick,
  onReadNotification,
  loadMoreNotifications,
  shouldLoadMoreNotifications,
  isAdmin,
}) {
  return (
    <div className="accountSwitcher">
      <span className="accountSwitcher_email">
        {team_member ? (
          <>
            {team_member.email}
            <br />
            <span className="sub_email">member of {client.data.email}</span>
          </>
        ) : (
          <>
            {client.data.email}
            {isAdmin && <small> ({client.data.id})</small>}
          </>
        )}
      </span>
      <Dropdown
        overlay={<AccountMenu client={client.data} onClick={onClick} team_member={team_member} isAdmin={isAdmin} />}
        placement="bottomLeft"
        trigger={['click']}
      >
        <Button type="primary" shape="circle" icon={<UserOutlined />} style={{marginRight: '10px'}} />
      </Dropdown>
      <Badge count={notifications.unreadNotificationsCount} overflowCount={10}>
        <Button type="primary" shape="circle" icon={<BellOutlined/>} onClick={() => toggleNotifications()} />
      </Badge>
      <Drawer
        title={
          <span>
            Notifications <Badge count={notifications.unreadNotificationsCount} overflowCount={10} />
          </span>
        }
        className="notifications-drawer"
        width={400}
        onClose={toggleNotifications}
        open={notifications.isOpen}
        bodyStyle={{paddingBottom: 80}}
      >
        <LazyNotificationsList notifications={notifications} onReadNotification={onReadNotification} />
        {shouldLoadMoreNotifications && (
          <VisibilitySensor
            onChange={(isVisible: boolean) => {
              if (isVisible) {
                loadMoreNotifications();
              }
            }}
            partialVisibility={true}
          >
            <span>{'Loading...'}</span>
          </VisibilitySensor>
        )}
      </Drawer>
    </div>
  );
}
